import { render, staticRenderFns } from "./QuickAutomove.vue?vue&type=template&id=181e960b&"
import script from "./QuickAutomove.vue?vue&type=script&lang=js&"
export * from "./QuickAutomove.vue?vue&type=script&lang=js&"
import style0 from "./QuickAutomove.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports